
import ClassificationItemModel from "./ClassificationItemModel"
import DropItemModel from "./DropItemModel";

class ClassificationContainerModel {
    constructor() {
        this.classificationItemContainerId = 0;
        this.classificationItemList = [];
        this.dropItemList = [];

        this.styleIndex = 0;
        this.initStyleArr()
        this.selectedStyle = this.styleArr[this.styleIndex]

    }

    initStyleArr = () => {
        this.styleArr = [
            [{ class: "border-change content-bg-change", style: { borderWidth: "0px", borderStyle: "solid", borderColor: "black" } }],
            [{ class: "border-change content-bg-change", style: { borderWidth: "1px", borderStyle: "solid", borderColor: "black" } }],
            [{ class: "border-change content-bg-change", style: { borderWidth: "2px", borderStyle: "solid", borderColor: "black" } }],
            [{ class: "border-change content-bg-change", style: { borderWidth: "3px", borderStyle: "solid", borderColor: "black" } }],

        ]
    }



    nextStyle = () => {

        if (this.styleIndex < this.styleArr.length - 1) {
            this.styleIndex++;
            this.selectedStyle = this.styleArr[this.styleIndex]
        }
    }

    prevStyle = () => {
        if (this.styleIndex > 0) {
            this.styleIndex--;
            this.selectedStyle = this.styleArr[this.styleIndex]
        }
    }

    addClassificationItem = () => {
        let ClassificationItem = new ClassificationItemModel();
        ClassificationItem.classificationItemName = "Column name";
        ClassificationItem.classificationItemIndex = this.classificationItemList.length
        this.classificationItemList.push(ClassificationItem);

        this.dropItemList.forEach(list => {
            list.push(new DropItemModel());
        });

       
    }


    addKeyItem = () => {
        this.dropItemList.push([]);

        for (let i = 0; i < this.classificationItemList.length; i++) {
            let dropItem = new DropItemModel()
            this.dropItemList[this.dropItemList.length - 1].push(dropItem)
        }
    }


    getAsJson = () => {
        let obj = {}
        obj.classificationItemContainerId = this.classificationItemContainerId;
        obj.selectedStyle = this.selectedStyle
        obj.classificationItemList = []
        for (let i = 0; i < this.classificationItemList.length; i++) {
            let item = new ClassificationItemModel()
            item = this.classificationItemList[i].getAsJson()
            obj.classificationItemList.push(item)
        }

        obj.dropItemList = []
        for (let i = 0; i < this.dropItemList.length; i++) {
            obj.dropItemList[i] = []
            for (let j = 0; j < this.dropItemList[i].length; j++) {
                obj.dropItemList[i].push(this.dropItemList[i][j].getAsJson())
            }
            // let item = new DropItemModel()
            // item=this.dropItemList[i].getAsJson()
            // obj.dropItemList.push(item)
        }

        return obj
    }


    initFromJson = (obj) => {

        this.classificationItemContainerId = obj.classificationItemContainerId;
        this.selectedStyle = obj.selectedStyle
        for (let i = 0; i < obj.classificationItemList.length; i++) {
            let item = new ClassificationItemModel()
            item.initFromJson(obj.classificationItemList[i])
            this.classificationItemList.push(item)
        }

        for (let i = 0; i < obj.dropItemList.length; i++) {
            this.dropItemList[i] = []
            for (let j = 0; j < obj.dropItemList[i].length; j++) {
                let item = new DropItemModel()
                item.initFromJson(obj.dropItemList[i][j])
                this.dropItemList[i].push(item)
            }

        }

    }

    deleteClassificationItem = (obj) => {
        //delete column
        this.classificationItemList = this.classificationItemList.filter(function (item, index) {
            if (obj.classificationItemIndex != item.classificationItemIndex)
                return item;
        })

        //delete drop item
        this.dropItemList.forEach(list => {
            list.splice(obj.classificationItemIndex, 1)
        });

        //reorder indexes
        var classificationItemIndex = 0;
        this.classificationItemList.forEach(element => {
            element.classificationItemIndex = classificationItemIndex;
            classificationItemIndex++;
        });
    }


    switchUpItem = (obj) => {

        const index = obj.classificationItemIndex;
        if (index != 0) {

            this.dropItemList.forEach(list => {
                let dropItem1 = list[index - 1]
                let dropItem2 = list[index]

                list[index - 1] = dropItem2;
                list[index] = dropItem1;

            });

            let Item1 = this.classificationItemList[index - 1]
            Item1.classificationItemIndex++

            let Item2 = this.classificationItemList[index]
            Item2.classificationItemIndex--


            this.classificationItemList[index - 1] = Item2
            this.classificationItemList[index] = Item1
        }
    }


    switchDownItem = (obj) => {
        const index = obj.classificationItemIndex;

        if (index != this.classificationItemList.length - 1) {

            this.dropItemList.forEach(list => {
                let dropItem1 = list[index]
                let dropItem2 = list[index + 1]

                list[index] = dropItem2;
                list[index + 1] = dropItem1;
            })


            let Item1 = this.classificationItemList[index]
            Item1.classificationItemIndex++

            let Item2 = this.classificationItemList[index + 1]
            Item2.classificationItemIndex--

            this.classificationItemList[index] = Item2
            this.classificationItemList[index + 1] = Item1
        }
    }
}
export default ClassificationContainerModel
